"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionHeaderMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Icon = require("../../components/Icon/Icon.styles");
var _Text = require("../../components/Text/Text.styles");
var _hoverMediaQueryMixin = require("../hoverMediaQueryMixin");
/** @class AccordionHeaderMixin */
/** @method */
var AccordionHeaderMixin = function AccordionHeaderMixin(props) {
  return (0, _styledToken.default)({
    backgroundColor: 'AccordionHeader.backgroundColor',
    backgroundColorHover: 'AccordionHeader.backgroundColorHover',
    borderRadius: 'AccordionHeader.borderRadius',
    padding: 'AccordionHeader.padding',
    textDecorationHover: 'AccordionHeader.textDecorationHover'
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
      backgroundColorHover = _ref.backgroundColorHover,
      borderRadius = _ref.borderRadius,
      padding = _ref.padding,
      textDecorationHover = _ref.textDecorationHover;
    return (0, _styledComponents.css)(["align-items:center;background-color:", ";border-radius:", "px;cursor:pointer;display:flex;padding:", "px;> ", "{flex-shrink:0;}&[aria-expanded='true'],&:hover,&:focus{background-color:", ";}", ";&[aria-expanded='true']{border-radius:", "px ", "px 0 0;> ", "{transform:rotate(180deg);}}"], backgroundColor, borderRadius, padding, _Icon.StyledIcon, backgroundColorHover, (0, _hoverMediaQueryMixin.hoverMediaQueryMixin)("\n                " + _Text.StyledText + ":first-child {\n                    text-decoration: " + textDecorationHover + ";\n                }\n            "), borderRadius, borderRadius, _Icon.StyledIcon);
  })(props);
};
exports.AccordionHeaderMixin = AccordionHeaderMixin;